import { AMOS as type } from '@/store/types';
import AssociateMemberOrganizations from '@/services/Api/AssociateMemberOrganizations';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  async fetchAMOs({ commit }) {
    commit(type.LOADING, true);

    try {
      const response = await AssociateMemberOrganizations.all();
      const { status, data } = response.data;

      if (status === 200) {
        commit(type.SET, data);
        return data;
      }

      return [];
    } finally {
      commit(type.LOADING, false);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
